import React from "react";
import { Link } from "react-router-dom";
import ProjectsSection from "../../components/ProjectsSection";
import Testimonials from "../../components/Testimonials";

const StaffAugmentation = () => {

  const projects = [
    { title: "Dedicated Dev Team", desc: "Scaled startup with remote engineers.", link: "#" },
    { title: "Design Support Team", desc: "Provided UI/UX designers for product team.", link: "#" },
  ];

  const testimonials = [
    { name: "Client X", role: "CTO", feedback: "Highly skilled professionals delivered fast." },
    { name: "Sarah Khan", role: "Startup Founder", feedback: "Seamless team integration." },
  ];

  return (
    <div className="text-white bg-black overflow-hidden">

      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center text-center px-6">
        <div className="absolute w-[500px] h-[500px] bg-yellow-500/30 blur-[120px] rounded-full top-20 left-1/2 -translate-x-1/2"></div>

        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-extrabold">
            Flexible <span className="text-yellow-400">Staff Augmentation</span>
          </h1>

          <p className="mt-6 text-gray-300 max-w-2xl mx-auto">
            Scale your team with top-tier professionals when you need them most.
          </p>

          <div className="mt-10 flex gap-4 justify-center flex-wrap">
            <Link to="/contact" className="px-8 py-4 bg-yellow-500 rounded-full">Hire Talent</Link>
            <a href="https://calendly.com/thelogicwaves/30min" className="px-8 py-4 border rounded-full">Book a Call</a>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="py-24 text-center max-w-5xl mx-auto px-6">
        <h2 className="text-4xl font-bold mb-6">Beyond Hiring</h2>
        <p className="text-gray-400">
          We provide dedicated professionals who integrate seamlessly into your workflows.
        </p>
      </section>

      {/* WHAT WE PROVIDE */}
      <section className="py-24 grid md:grid-cols-3 gap-8 max-w-6xl mx-auto px-6">
        {["Developers","Designers","QA Engineers","Project Managers","AI Experts","Flexible Contracts"].map((item,i)=>(
          <div key={i} className="bg-white/5 p-6 rounded-xl border border-white/10">
            <h3 className="text-yellow-400">{item}</h3>
          </div>
        ))}
      </section>

      {/* PROCESS */}
      <section className="py-24 bg-[#0b1a35] text-center">
        <h2 className="text-4xl font-bold mb-12">Our Process</h2>
        <div className="grid md:grid-cols-4 gap-8">
          {["Understand","Recruit","Integrate","Support"].map((step,i)=>(
            <div key={i}>
              <div className="text-yellow-400 text-2xl font-bold">{i+1}</div>
              <p>{step}</p>
            </div>
          ))}
        </div>
      </section>

      <ProjectsSection projects={projects} />
      <Testimonials testimonials={testimonials} />

      {/* CTA */}
      <section className="py-28 text-center bg-gradient-to-r from-yellow-500 to-orange-500">
        <h2 className="text-4xl font-bold mb-6">Build Your Dream Team 🚀</h2>
        <Link to="/contact" className="bg-black px-6 py-3 rounded">Contact Us</Link>
      </section>

    </div>
  );
};

export default StaffAugmentation;